export default __webpack_public_path__ + "static/media/horizontal_line.2586a26d.svg";